import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Legacy `/create` URL — send users to the current create flow. */
export default function CreateLegacyRedirect() {
    const location = useLocation();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const userId = sessionStorage.getItem('uid');

        if (!userId || !sessionStorage.getItem('token')) {
            navigate('/signin', {
                replace: true,
                state: {
                    message: t('common.signInToCreateCourse'),
                    redirectTo: '/create-choice',
                },
            });
            return;
        }

        navigate('/create-choice', {
            replace: true,
            state: {
                ...location.state,
                from: location.state?.from || location.pathname,
            },
        });
    }, [navigate, location.pathname, location.state, t]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-100 dark:bg-slate-950 px-4">
            <div className="text-center">
                <div className="animate-spin rounded-full h-10 w-10 border-2 border-indigo-200 dark:border-slate-700 border-t-indigo-600 dark:border-t-indigo-400 mx-auto mb-3" aria-hidden />
                <p className="text-slate-600 dark:text-slate-400 text-sm font-medium">{t('common.redirecting')}</p>
            </div>
        </div>
    );
}
